/* eslint-disable react/prop-types */
// NOTE: This is an example of a compound component. Internally it uses MUI Modal Component and wrap it with the context API.
// You can use it like this:
// <CompoundModal>
//    <CompoundModal.Open name="modal1">
//       <button>Open Modal 1</button>
//    </CompoundModal.Open>
//    <CompoundModal.Window name="modal1">
//       <div>Modal 1 Content</div>
//    </CompoundModal.Window>
//    <CompoundModal.Open name="modal2">
//       <button>Open Modal 2</button>
//    </CompoundModal.Open>
//    <CompoundModal.Window name="modal2">
//       <div>Modal 2 Content</div>
//    </CompoundModal.Window>
// </CompoundModal>

import { Modal } from "@mui/material";
import React, { cloneElement, createContext, useState } from "react";
import { HiXMark } from "react-icons/hi2";


const ModalContext = createContext();

function CompoundModal({ children }) {
  const [openName, setOpenName] = useState("");

  const open = setOpenName;
  const close = () => setOpenName("");

  return (
    <ModalContext.Provider value={{ openName, open, close }}>
      {children}
    </ModalContext.Provider>
  );
}

function Open({ children, name }) {
  const { open } = React.useContext(ModalContext);

  if (!children) return;

  return cloneElement(children, {
    onClick: () => {
      if (children?.props?.onClick) {
        children.props.onClick();
      }
      open(name);
    },
  });
}

function Window({ children, name }) {
  const { openName, close } = React.useContext(ModalContext);

  if (openName !== name) return null;

  return (
    <Modal
      open={true}
      onClose={close}
      backdrop="true"
      sx={{
        "& > .MuiBackdrop-root": {
          backdropFilter: "blur(3px)", // Adjust blur strength as needed
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional: adjust backdrop color and opacity
        },
      }}
    >
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 shadow-xl p-16 rounded-[6px] bg-background"
      >
        <div className="flex justify-end mb-2 cursor-pointer absolute top-4 right-6">
          <HiXMark className="fs-24" onClick={close} />
        </div>
        {cloneElement(children, {
          handleCloseModal: () => {
            if (children?.props?.onClose) {
              children.props.onClose();
            }
            close();
          },
        })}
      </div>
    </Modal>
  );
}

CompoundModal.Open = Open;
CompoundModal.Window = Window;

export default CompoundModal;
